import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Pencil, Plus, Save, Trash2, X } from "lucide-react";
import { deleteEvent, errText, fetchEvents, ron, saveEvent } from "@/lib/bf";
import BFEventPkg from "./BFEventPkg";

const BR = [["medavita", "Medavita"], ["framesi", "Framesi"], ["lalga", "L'Alga"], ["mowan", "Mowan"]];
const EMPTY = { brand: "medavita", name: "", dates: "", place: "", condition: "", min_value: 0, deadline: "", seats: 0, desc: "", pkg_name: "", pkg_gamas: [], pkg_products: [], from_date: "", to_date: "" };
const F = ({ l, k, v, set, type = "text", wide, ph }) => (
  <label className={`st-field bfc-f ${wide ? "is-wide" : ""}`}><span className="st-label">{l}</span>
    {type === "area" ? <textarea rows={3} value={v[k]} onChange={(e) => set({ ...v, [k]: e.target.value })} placeholder={ph} data-testid={`bf-eva-${k}`} />
      : <input type={type} value={v[k]} onChange={(e) => set({ ...v, [k]: e.target.value })} placeholder={ph} data-testid={`bf-eva-${k}`} />}
  </label>
);

export default function BFEventsAdmin() {
  const [rows, setRows] = useState(null);
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchEvents().then(setRows).catch(() => setRows([])); }, []);
  const save = () => {
    setBusy(true);
    saveEvent({ ...v, min_value: Number(v.min_value) || 0, seats: Number(v.seats) || 0 }).then((d) => {
      setRows((l) => (v.id ? l.map((x) => (x.id === v.id ? { ...x, ...v } : x)) : [d, ...l])); setV(null); toast.success("Eveniment salvat");
    }).catch((e) => toast.error(errText(e, "Completează numele evenimentului"))).finally(() => setBusy(false));
  };
  const del = (e) => window.confirm(`Ștergi evenimentul ${e.name}? Se șterg și înscrierile.`) && deleteEvent(e.id).then(() => setRows((l) => l.filter((x) => x.id !== e.id)));
  return (
    <section className="invite-box" data-testid="bf-events-admin">
      <h3>Evenimente internaționale</h3>
      {!v && <button type="button" className="st-btn st-btn--silver" onClick={() => setV(EMPTY)} data-testid="bf-eva-new"><Plus size={14} /> Eveniment nou</button>}
      {v && (
        <div className="bfc-grid bf-eva-form">
          <label className="st-field bfc-f"><span className="st-label">Brand</span><select value={v.brand} onChange={(e) => setV({ ...v, brand: e.target.value, pkg_gamas: [], pkg_products: [] })} data-testid="bf-eva-brand">{BR.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
          <F l="Nume eveniment *" k="name" v={v} set={setV} ph="ex. Medavita Hair Show Milano" />
          <F l="Date" k="dates" v={v} set={setV} ph="ex. 12–14 martie 2027" />
          <F l="Loc" k="place" v={v} set={setV} ph="ex. Milano, Italia" />
          <F l="Termen înscriere" k="deadline" type="date" v={v} set={setV} />
          <F l="Locuri (0 = nelimitat)" k="seats" type="number" v={v} set={setV} />
          <F l="Achiziție minimă (lei)" k="min_value" type="number" v={v} set={setV} />
          <F l="Achiziții numărate de la" k="from_date" type="date" v={v} set={setV} />
          <F l="Până la" k="to_date" type="date" v={v} set={setV} />
          <F l="Nume pachet" k="pkg_name" v={v} set={setV} ph="ex. Pachet Luxviva Milano" />
          <BFEventPkg v={v} set={setV} />
          <F l="Condiția de achiziție" k="condition" wide v={v} set={setV} ph="ex. comandă de minim 5.000 lei din gama Luxviva până la 31 ianuarie" />
          <F l="Detalii" k="desc" type="area" wide v={v} set={setV} />
          <div className="share-actions bfc-f is-wide">
            <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy || v.name.trim().length < 2} data-testid="bf-eva-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează</button>
            <button type="button" className="st-btn st-btn--ghost" onClick={() => setV(null)} data-testid="bf-eva-cancel"><X size={14} /> Renunță</button>
          </div>
        </div>
      )}
      {!rows ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <ul className="bf-evs">
          {!rows.length && <li className="st-hint">Niciun eveniment încă.</li>}
          {rows.map((e) => (
            <li key={e.id} className="bf-ev" data-testid={`bf-eva-row-${e.id}`}>
              <b>{BR.find(([k]) => k === e.brand)?.[1]} · {e.name}</b>
              <div className="bf-ev-meta">{e.dates && <span>{e.dates}</span>}{e.place && <span>{e.place}</span>}{e.deadline && <span>înscrieri până pe {new Date(`${e.deadline}T12:00:00`).toLocaleDateString("ro-RO")}</span>}<span>{e.registered} înscriși{e.seats ? ` / ${e.seats}` : ""}</span>{e.min_value > 0 && <span>min. {ron(e.min_value)}</span>}{e.pkg_name && <span>pachet: {e.pkg_name}</span>}{e.from_date && <span>achiziții {new Date(`${e.from_date}T12:00:00`).toLocaleDateString("ro-RO")}{e.to_date ? ` – ${new Date(`${e.to_date}T12:00:00`).toLocaleDateString("ro-RO")}` : ""}</span>}</div>
              {e.condition && <p className="bf-ev-cond">Condiție: {e.condition}</p>}
              <div className="share-actions">
                <button type="button" className="st-btn st-btn--ghost" onClick={() => setV({ ...EMPTY, ...e })} data-testid={`bf-eva-edit-${e.id}`}><Pencil size={14} /> Modifică</button>
                <button type="button" className="st-btn st-btn--ghost" onClick={() => del(e)} data-testid={`bf-eva-del-${e.id}`}><Trash2 size={14} /> Șterge</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
